import { createElement, forwardRef } from 'react';
import { atoms } from '../../css/atoms/atoms.css';
import classNames from 'classnames';

import type { AllHTMLAttributes, ElementType } from 'react';
import type { Atoms } from '../../css/atoms/atoms.css';

export interface BaseBoxProps extends Atoms {
  className?: string;
}

export interface BoxProps
  extends BaseBoxProps,
    Omit<AllHTMLAttributes<HTMLElement>, 'width' | 'height' | 'className'> {
  component?: ElementType;
}

export const Box = forwardRef<HTMLElement, BoxProps>(
  ({ component = 'div', className, ...restProps }, ref) => {
    const atomProps: Record<string, unknown> = {};
    const nativeProps: Record<string, unknown> = {};

    for (const key in restProps) {
      if (atoms.properties.has(key as keyof Atoms)) {
        atomProps[key] = restProps[key as keyof typeof restProps];
      } else {
        nativeProps[key] = restProps[key as keyof typeof restProps];
      }
    }

    const atomicClasses = atoms({ ...atomProps });
    const classes = classNames(className, atomicClasses);

    return createElement(component, {
      className: classes,
      ...nativeProps,
      ref,
    });
  }
);

Box.displayName = 'Box';
